var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{staticClass:"left-bar",attrs:{"disable-route-watcher":"","temporary":"","app":"","width":"300"},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('left-bar-items')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }